<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-switch
      v-model="optionModel.defaultValue"
      @change="emitDefaultValueChange"
      :active-value="optionModel.activeValue"
      :inactive-value="optionModel.inactiveValue"
      :active-text="optionModel.activeLabel || optionModel.activeValue.toString()"
      :inactive-text="optionModel.inactiveLabel || optionModel.inactiveValue.toString()"
    ></el-switch>
  </el-form-item>
</template>

<script>
import { toRefs } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'm-switch-defaultValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
    };
  },
};
</script>

<style scoped></style>
